module.exports = __webpack_public_path__ + "static/assets/af6742adb2da1c52c53df206ba11584a.svg";